export default __webpack_public_path__ + "static/LeituraTwo-BlackItalic-a0a37ab98529987853a3b5410d7133f9.woff2";